import { api } from '../config/api'

const baseEndpoint = '/AcademicCourseApi'
const programEndpoint = '/EducationalProgramApi'
const resourceEndpoint = '/ResourceApi'

export const getContentResources = ({ programId, locale }) =>
  api.get(`${programEndpoint}/${programId}/ClassPlans`, { params: { locale } })

export const getResourceClasses = (resourceId) =>
  api.get(`${resourceEndpoint}/${resourceId}/ClassPlans`)

export const registerUsedContent = (data) =>
  api.post(`${baseEndpoint}/UsedContentRecord`, data)
